module.exports = __webpack_public_path__ + "media/images/redesign-images/rewards/loyalty-path-two-a54f92c2b843feb45fb6fca164825b8a.png";